import React, { Fragment, useEffect, useState } from "react";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Dialog, Transition, Menu } from "@headlessui/react";
import { OFICINAS_POR_MUNICIPIO } from "../catalogos/oficinasPorMunicipio";
import LoaderPremiumLogo from "../components/LoaderPremiumLogo"; // ⬅️ IMPORTANTE

import axios from "axios";
import { API_BASE } from "../apiConfig";

export default function InventarioView() {
  // LOADING + INVENTARIO
  const [loading, setLoading] = useState(true);
  const [inventario, setInventario] = useState([]);

  // FILTROS
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("Todos");
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState("Todos");
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState("Todos");
  const [oficinaSeleccionada, setOficinaSeleccionada] = useState("Todos");
  const [moduloSeleccionado, setModuloSeleccionado] = useState("Todos");
  const [busqueda, setBusqueda] = useState("");

  // EDICIÓN
  const [editando, setEditando] = useState(null);

  // ============================
  // CARGAR INVENTARIO
  // ============================
  const cargarInventario = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/inventario`);
      setInventario(res.data || []);
    } catch (err) {
      console.error("ERROR GET INVENTARIO:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarInventario();
  }, []);

  // ============================
  // LOADER PREMIUM (AQUÍ ES DONDE SE COLOCA SIEMPRE)
  // ============================
  if (loading) {
    return <LoaderPremiumLogo />; // ⬅️ AQUÍ EXACTAMENTE VA EL LOADER PREMIUM
  }

  // ============================
  // ELIMINAR
  // ============================
const eliminarEquipo = async (item) => {
  if (
    !window.confirm(
      `¿Seguro que deseas eliminar el equipo del proyecto "${item.proyecto}"?`
    )
  )
    return;

  try {
    await axios.delete(`${API_BASE}/inventario`, {
      params: {
        proyecto: item.proyecto, // ✅ PARTITION KEY REAL
        sk: item.sk,             // ✅ SORT KEY REAL
      },
    });

    alert("Equipo eliminado correctamente");
    cargarInventario();

  } catch (err) {
    console.error("ERROR DELETE:", err);
    alert("No se pudo eliminar el equipo");
  }
};




  // ============================
  // GUARDAR EDICIÓN
  // ============================
  const guardarEdicion = async () => {
    try {
      await axios.put(`${API_BASE}/inventario/${editando.id}`, editando);
      setEditando(null);
      cargarInventario();
    } catch (err) {
      console.error("ERROR UPDATE:", err);
      alert("No se pudo actualizar");
    }
  };

  // ============================
  // EXPORTAR A EXCEL
  // ============================
  const exportarExcel = () => {
    if (inventarioFiltrado.length === 0) {
      alert("La tabla está vacía");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(inventarioFiltrado);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inventario");

    XLSX.writeFile(wb, "Inventario_Equipos.xlsx");
  };

  // ============================
  // EXPORTAR PDF
  // ============================
  const exportarPDF = () => {
    if (inventarioFiltrado.length === 0) {
      alert("La tabla está vacía");
      return;
    }

    const doc = new jsPDF({ orientation: "landscape" });

    doc.setFontSize(18);
    doc.text("Inventario de Equipos - IMOVEQROO", 14, 15);

    const columnas = [
      "ID",
      "Equipo",
      "Marca",
      "Modelo",
      "Serie",
      "Estado",
      "Proyecto",
      "Municipio",
      "Oficina",
      "Módulo",
      "Notas",
    ];

    const filas = inventarioFiltrado.map((item) => [
      item.id,
      item.equipo,
      item.marca,
      item.modelo,
      item.serie,
      item.estadoEquipo,
      item.proyecto,
      item.municipio,
      item.oficina,
      item.modulo,
      item.notas,
    ]);

    autoTable(doc, {
      startY: 25,
      head: [columnas],
      body: filas,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      margin: { left: 10, right: 10 },
    });

    doc.save("Inventario_Equipos.pdf");
  };

  // ============================
  // OPCIONES SELECT
  // ============================
  const estados = ["Todos", ...new Set(inventario.map((i) => i.estadoEquipo))];
  const proyectos = ["Todos", ...new Set(inventario.map((i) => i.proyecto))];
  const municipios = ["Todos", ...Object.keys(OFICINAS_POR_MUNICIPIO)];

  const oficinas =
    municipioSeleccionado !== "Todos"
      ? ["Todos", ...(OFICINAS_POR_MUNICIPIO[municipioSeleccionado] || [])]
      : ["Todos", ...new Set(inventario.map((i) => i.oficina))];

  // ⭐⭐⭐⭐⭐ NUEVA LÓGICA DE MÓDULOS ⭐⭐⭐⭐⭐
  const modulos = [
    "Todos",
    ...new Set(
      inventario
        .filter((i) =>
          municipioSeleccionado === "Todos" ? true : i.municipio === municipioSeleccionado
        )
        .filter((i) =>
          oficinaSeleccionada === "Todos" ? true : i.oficina === oficinaSeleccionada
        )
        .map((i) => i.modulo?.toString().trim())
        .filter((m) => m && m !== "0" && m !== "null" && m !== "undefined")
    ),
  ].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

  // ============================
  // FILTRO COMPLETO
  // ============================
  const inventarioFiltrado = inventario.filter((i) => {
    if (estadoSeleccionado !== "Todos" && i.estadoEquipo !== estadoSeleccionado) return false;
    if (proyectoSeleccionado !== "Todos" && i.proyecto !== proyectoSeleccionado) return false;
    if (municipioSeleccionado !== "Todos" && i.municipio !== municipioSeleccionado) return false;
    if (oficinaSeleccionada !== "Todos" && i.oficina !== oficinaSeleccionada) return false;
    if (moduloSeleccionado !== "Todos" && i.modulo !== moduloSeleccionado) return false;

    if (busqueda.trim()) {
      const texto = busqueda.toLowerCase();
      const datos = Object.values(i).join(" ").toLowerCase();
      if (!datos.includes(texto)) return false;
    }

    return true;
  });

  // ============================
  // CLASES ESTADO
  // ============================
  const estadoBadgeClasses = (estado) => {
    switch (estado) {
      case "BUENO":
        return "bg-emerald-100 text-emerald-700";
      case "EN REPARACIÓN":
        return "bg-amber-100 text-amber-700";
      case "MAL ESTADO":
      case "NO OPERATIVO":
        return "bg-rose-100 text-rose-700";
      default:
        return "bg-slate-100 text-slate-700";
    }
  };

  // ============================
  // RENDER
  // ============================
  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="mb-4">
        <h1 className="text-3xl font-bold text-slate-900">
          Inventario de Equipos por Proyecto
        </h1>
        <p className="text-slate-500 text-sm mt-1">
          Panel de control de equipos, módulos y proyectos de IP DEPOT.
        </p>
      </div>

      {/* FILTROS */}
      <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4 mb-4 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">

          {/* Municipio */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-600">Municipio</label>
            <select
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
              value={municipioSeleccionado}
              onChange={(e) => {
                setMunicipioSeleccionado(e.target.value);
                setOficinaSeleccionada("Todos");
                setModuloSeleccionado("Todos");
              }}
            >
              {municipios.map((m) => (
                <option key={m}>{m}</option>
              ))}
            </select>
          </div>

          {/* Oficina */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-600">Oficina</label>
            <select
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-500"
              value={oficinaSeleccionada}
              onChange={(e) => {
                setOficinaSeleccionada(e.target.value);
                setModuloSeleccionado("Todos");
              }}
            >
              {oficinas.map((o) => (
                <option key={o}>{o}</option>
              ))}
            </select>
          </div>

          {/* Estado */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-600">Estado</label>
            <select
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm"
              value={estadoSeleccionado}
              onChange={(e) => setEstadoSeleccionado(e.target.value)}
            >
              {estados.map((o) => (
                <option key={o}>{o}</option>
              ))}
            </select>
          </div>

          {/* Proyecto */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-600">Proyecto</label>
            <select
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm"
              value={proyectoSeleccionado}
              onChange={(e) => setProyectoSeleccionado(e.target.value)}
            >
              {proyectos.map((o) => (
                <option key={o}>{o}</option>
              ))}
            </select>
          </div>

          {/* Módulo */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-600">Módulo</label>
            <select
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm"
              value={moduloSeleccionado}
              onChange={(e) => setModuloSeleccionado(e.target.value)}
            >
              {modulos.map((o) => (
                <option key={o}>{o}</option>
              ))}
            </select>
          </div>

          {/* Búsqueda */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-600">Búsqueda</label>
            <input
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm"
              placeholder="Buscar cualquier dato..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
          </div>
        </div>

        {/* BOTONES EXPORTACIÓN */}
        <div className="mt-4 flex flex-wrap gap-3">
          <button
            onClick={exportarExcel}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-emerald-600 text-white text-sm font-semibold shadow-md hover:bg-emerald-700"
          >
            📊 Exportar Excel
          </button>
          <button
            onClick={exportarPDF}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-rose-600 text-white text-sm font-semibold shadow-md hover:bg-rose-700"
          >
            📕 Exportar PDF
          </button>
        </div>
      </div>

      {/* TABLA */}
      <div className="mt-4 border border-slate-200 rounded-2xl bg-white shadow-md overflow-auto max-h-[65vh]">
        <table className="min-w-full border-collapse text-sm">
          <thead className="bg-slate-900 text-white sticky top-0 z-20">
            <tr>
              {[
                "ID",
                "Equipo",
                "Marca",
                "Modelo",
                "Serie",
                "Estado",
                "Proyecto",
                "Municipio",
                "Oficina",
                "Módulo",
                "Notas",
                "Acciones",
              ].map((th) => (
                <th
                  key={th}
                  className="px-4 py-3 text-left font-semibold text-xs uppercase tracking-wide"
                >
                  {th}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {inventarioFiltrado.map((i, index) => (
              <tr
                key={i.sk}
                className={`border-b border-slate-100 hover:bg-slate-50 transition ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/70"
                }`}
              >
                <td className="px-4 py-2">{i.id}</td>
                <td className="px-4 py-2">{i.equipo}</td>
                <td className="px-4 py-2">{i.marca}</td>
                <td className="px-4 py-2">{i.modelo}</td>
                <td className="px-4 py-2">{i.serie}</td>

                <td className="px-4 py-2">
                  <span
                    className={`px-3 py-1 rounded-full text-[11px] font-semibold ${estadoBadgeClasses(
                      i.estadoEquipo
                    )}`}
                  >
                    {i.estadoEquipo}
                  </span>
                </td>

                <td className="px-4 py-2">{i.proyecto}</td>
                <td className="px-4 py-2">{i.municipio}</td>
                <td className="px-4 py-2">{i.oficina}</td>
                <td className="px-4 py-2">{i.modulo}</td>
                <td className="px-4 py-2">{i.notas}</td>

                {/* ACCIONES */}
                <td className="px-4 py-2">
                  <Menu as="div" className="relative inline-block text-left">
                    <Menu.Button className="text-xl text-slate-600 hover:text-slate-900">
                      ⋮
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 mt-2 w-32 bg-white border border-slate-200 rounded-xl shadow-lg z-50">
                        <div className="py-1">
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => setEditando(i)}
                                className={`w-full text-left px-3 py-2 text-sm ${
                                  active ? "bg-slate-100" : ""
                                }`}
                              >
                                ✏️ Editar
                              </button>
                            )}
                          </Menu.Item>

                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => eliminarEquipo(i)}
                                className={`w-full text-left px-3 py-2 text-sm text-rose-600 ${
                                  active ? "bg-rose-50" : ""
                                }`}
                              >
                                🗑 Eliminar
                              </button>
                            )}
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </td>
              </tr>
            ))}

            {inventarioFiltrado.length === 0 && (
              <tr>
                <td
                  colSpan={12}
                  className="px-4 py-6 text-center text-slate-500 text-sm"
                >
                  No se encontraron equipos con los filtros seleccionados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL EDITAR */}
      <Transition appear show={!!editando} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => setEditando(null)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-150"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-150"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
                  <Dialog.Title className="text-xl font-semibold text-slate-900 mb-4">
                    Editar Equipo
                  </Dialog.Title>

                  {editando && (
                    <div className="space-y-3 max-h-[50vh] overflow-y-auto pr-1">
                      {Object.keys(editando).map((key) =>
                        key === "sk" ? null : (
                          <div key={key} className="flex flex-col gap-1">
                            <label className="text-xs font-semibold text-slate-600">
                              {key}
                            </label>
                            <input
                              className="rounded-xl border border-slate-300 px-3 py-2 text-sm shadow-sm"
                              value={editando[key] || ""}
                              onChange={(e) =>
                                setEditando({
                                  ...editando,
                                  [key]: e.target.value,
                                })
                              }
                            />
                          </div>
                        )
                      )}
                    </div>
                  )}

                  <div className="mt-6 flex flex-col gap-2">
                    <button
                      onClick={guardarEdicion}
                      className="w-full bg-blue-600 px-4 py-2 rounded-xl text-white font-semibold hover:bg-blue-700"
                    >
                      Guardar cambios
                    </button>
                    <button
                      onClick={() => setEditando(null)}
                      className="w-full bg-slate-200 px-4 py-2 rounded-xl text-slate-800"
                    >
                      Cancelar
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

    </div>
  );
}
